import { FC } from 'react'
import reactStringReplace from 'react-string-replace'

import { useFeatureFlag } from '../../../../../../app/_providers/ExperimentationProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import { StyleLinkItem } from './StyleLinkItem'
import { Container } from './styles'
import { useTranslatedStyleLinks } from './useTranslatedStyleLinks'

type Props = {
  productGroupHandle: string
}

export const StyleLinks: FC<Props> = ({ productGroupHandle }) => {
  const otherStyles = useTranslatedStyleLinks(productGroupHandle)

  const flag = useFeatureFlag<'false' | 'true'>({
    key: 'pdp-other-styles-link',
    controlVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'lock-pageview-to-controlVariant',
    skip: !otherStyles,
  })

  const {
    pages: {
      product: {
        styleLinks: { alsoAvailableInSingle: alsoAvailableInSingleTextTemplate },
      },
    },
  } = useTranslation()

  if (flag !== 'true' || !otherStyles) return null

  // Only handle single style case since all entries have exactly 1 alternative for now
  const style = otherStyles[0]

  const alsoAvailableInSingleTextWithLink = reactStringReplace(
    alsoAvailableInSingleTextTemplate,
    '{{style}}',
    (_match, _index) => {
      return <StyleLinkItem title={style.title} handle={style.handle} />
    }
  )

  return <Container>{alsoAvailableInSingleTextWithLink}</Container>
}
